// ListingsPageStyles.js



import theme from './../../theme';

export const styles = {
  searchSection: {
    padding: '40px 20px',
    backgroundColor: theme.colors.white, 
  },
  searchHeading: {
    fontFamily: theme.fonts.secondary,
    color: theme.colors.darkGray, 
    textAlign: 'center',
    marginBottom: '24px', 
    fontSize: '1.8rem',
    fontWeight: '700',
  },
  listingsSection: {
    padding: '40px 20px',
    backgroundColor: theme.colors.extraLightGray, 
    minHeight: '80vh',
  },
  listingsHeading: {
    fontFamily: theme.fonts.secondary,
    color: theme.colors.darkGray, 
    textAlign: 'center',
    marginBottom: '32px',
    fontSize: '2rem',
    fontWeight: '800',
  },
  paper: {
    padding: '16px',
    backgroundColor: theme.colors.white,
    borderRadius: '8px', // Rounded edges for modern design
    boxShadow: theme.shadows.medium, // Subtle shadow for depth
  },
  image: {
    width: '100%',
    height: '200px',
    objectFit: 'cover',
    borderRadius: '8px', // Rounded corners for a sleek look
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)', // Subtle shadow for images
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '16px',
    gap: '8px', // Adds spacing between pagination items
    color: theme.colors.darkGray,
  },
};
